(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-hero-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rf-gel-stage')) {
    class RfGelStage extends HTMLElement {
      connectedCallback() {
        this.setupFit();
        this.gelHandlers = [];
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        // Cursor only matters on a pouch itself: that one tilts a little toward it.
        const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
        if (this.hasAttribute('data-tilt') && fine.matches) {
          this.querySelectorAll('.rfgs__gel').forEach((gel) => {
            const item = gel.closest('.rfgs__item');
            if (!item) return;
            const move = (ev) => {
              const r = gel.getBoundingClientRect();
              const x = Math.max(-1, Math.min(1, ((ev.clientX - r.left) / r.width) * 2 - 1));
              item.style.setProperty('--mx', x.toFixed(3));
            };
            const leave = () => item.style.setProperty('--mx', '0');
            gel.addEventListener('pointermove', move, { passive: true });
            gel.addEventListener('pointerleave', leave);
            this.gelHandlers.push([gel, move, leave]);
          });
        }
      }

      // ---- Background type that fills the band (phones and tablets) ----
      setupFit() {
        this.fitWord = this.fitWord.bind(this);
        this.queueFit = () => {
          cancelAnimationFrame(this.fitRaf);
          this.fitRaf = requestAnimationFrame(this.fitWord);
        };
        if (window.ResizeObserver) {
          this.ro = new ResizeObserver(this.queueFit);
          this.ro.observe(this);
        }
        if (document.fonts) {
          document.fonts.ready.then(this.queueFit);
          document.fonts.addEventListener('loadingdone', this.queueFit);
        }
        // Wait for the load-in (pouches decoded, heading font loaded) before the first
        // draw, so the letters arrive with the pouches and are never redrawn in a new font.
        if (this.classList.contains('rfgs--wait') && !this.classList.contains('rfgs--in')) {
          this.inMo = new MutationObserver(() => {
            if (!this.classList.contains('rfgs--in')) return;
            this.inMo.disconnect();
            this.inMo = null;
            this.queueFit();
          });
          this.inMo.observe(this, { attributes: true, attributeFilter: ['class'] });
        } else {
          this.queueFit();
        }
      }

      fitWord() {
        if (this.inMo || !window.rfgsFit) return;
        window.rfgsFit(this);
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.inMo) this.inMo.disconnect();
        if (document.fonts) document.fonts.removeEventListener('loadingdone', this.queueFit);
        (this.gelHandlers || []).forEach(([gel, move, leave]) => {
          gel.removeEventListener('pointermove', move);
          gel.removeEventListener('pointerleave', leave);
        });
      }
    }
    customElements.define('rf-gel-stage', RfGelStage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-science-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.rf-sci');
    roots.forEach(function (root) {
      /* ── offset for in-page jumps: header + sticky chip nav + a little air ── */
      var nav = root.querySelector('.rf-sci__nav');
      var offset = function () {
        var h = 0;
        var hv = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        if (hv) h += parseFloat(hv) || 0;
        if (nav) h += nav.offsetHeight;
        return h + 20;
      };
      var scrollTo = function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        var top = el.getBoundingClientRect().top + window.pageYOffset - offset();
        try { window.scrollTo({ top: top, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, top); }
      };
      root.querySelectorAll('a[data-rf-scroll]').forEach(function (a) {
        a.addEventListener('click', function (ev) {
          var id = (a.getAttribute('href') || '').replace('#', '');
          if (!id || !document.getElementById(id)) return;
          ev.preventDefault();
          scrollTo(id);
          if (history.replaceState) history.replaceState(null, '', '#' + id);
        });
      });

      /* ── active chip while scrolling ── */
      var links = Array.prototype.slice.call(root.querySelectorAll('.rf-sci__chips a'));
      if (links.length && 'IntersectionObserver' in window) {
        var byId = {};
        links.forEach(function (a) {
          var id = (a.getAttribute('href') || '').replace('#', '');
          if (document.getElementById(id)) byId[id] = a;
        });
        var setActive = function (id) {
          links.forEach(function (a) { a.classList.toggle('is-active', a === byId[id]); });
          var active = byId[id];
          if (active && active.scrollIntoView) {
            try { active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) {}
          }
        };
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.isIntersecting) setActive(entry.target.id); });
        }, { rootMargin: '-35% 0px -55% 0px', threshold: 0 });
        Object.keys(byId).forEach(function (id) { io.observe(document.getElementById(id)); });
      }

      /* ── footnotes: popover on tap + short source line per section ── */
      var pop = root.querySelector('.rf-sci__pop');
      var popBody = pop ? pop.querySelector('.rf-sci__pop-body') : null;
      var srcFor = function (n) { return root.querySelector('#rf-src-' + n); };
      var openPop = function (btn) {
        var n = btn.getAttribute('data-ref');
        var li = srcFor(n);
        if (!pop || !li) { location.hash = 'rf-src-' + n; return; }
        popBody.innerHTML = '<span class="rf-sci__pop-num">' + n + '</span>' + li.innerHTML;
        pop.hidden = false;
        pop.style.visibility = 'hidden';
        var r = btn.getBoundingClientRect();
        var pw = pop.offsetWidth;
        var left = r.left + window.pageXOffset - pw / 2 + r.width / 2;
        var minLeft = 12 + window.pageXOffset;
        var maxLeft = window.innerWidth - pw - 12 + window.pageXOffset;
        left = Math.max(minLeft, Math.min(left, maxLeft));
        var top = r.bottom + window.pageYOffset + 8;
        pop.style.left = left + 'px';
        pop.style.top = top + 'px';
        pop.style.visibility = '';
        pop.setAttribute('data-open', n);
        root.querySelectorAll('.rf-sci__fn button[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        btn.setAttribute('aria-expanded', 'true');
      };
      var closePop = function () {
        if (!pop || pop.hidden) return;
        pop.hidden = true;
        pop.removeAttribute('data-open');
        root.querySelectorAll('.rf-sci__fn button[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      };
      root.querySelectorAll('.rf-sci__fn button').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-haspopup', 'dialog');
        var n = btn.getAttribute('data-ref');
        var li = srcFor(n);
        if (li) btn.setAttribute('title', li.getAttribute('data-short') || '');
        btn.addEventListener('click', function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          if (pop && !pop.hidden && pop.getAttribute('data-open') === n) { closePop(); return; }
          openPop(btn);
        });
      });
      if (pop) {
        pop.querySelector('.rf-sci__pop-close').addEventListener('click', closePop);
        pop.addEventListener('click', function (ev) { ev.stopPropagation(); });
        document.addEventListener('click', closePop);
        document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closePop(); });
      }

      /* short source list under each section that cites something */
      var label = root.getAttribute('data-sources-label') || 'Sources';
      root.querySelectorAll('.rf-sci__section').forEach(function (sec) {
        if (sec.id === 'rf-sources') return;
        var seen = {}; var order = [];
        sec.querySelectorAll('.rf-sci__fn button').forEach(function (b) {
          var n = b.getAttribute('data-ref');
          if (!seen[n]) { seen[n] = true; order.push(n); }
        });
        if (!order.length) return;
        var wrap = document.createElement('div');
        wrap.className = 'rf-sci__refs';
        var html = '<span class="rf-sci__refs-label">' + label + ':</span> ';
        html += order.map(function (n) {
          var li = srcFor(n);
          if (!li) return '';
          var link = li.querySelector('a');
          var short = li.getAttribute('data-short') || ('[' + n + ']');
          return '<a class="rf-sci__refs-item" href="' + (link ? link.getAttribute('href') : '#rf-src-' + n) + '"' + (link ? ' target="_blank" rel="noopener"' : '') + '><b>' + n + '</b> ' + short + '</a>';
        }).join('');
        wrap.innerHTML = html;
        sec.appendChild(wrap);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-science-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.rf-sci');
    roots.forEach(function (root) {
      /* ── sticky theme header: measure it, expose as --rf-header-h ── */
      var themeHeader = document.querySelector('.header-section, header.shopify-section');
      var headerH = function () {
        if (!themeHeader) return 0;
        var pos = getComputedStyle(themeHeader).position;
        var inner = themeHeader.querySelector('.header') || themeHeader;
        var ipos = getComputedStyle(inner).position;
        if (pos === 'sticky' || pos === 'fixed' || ipos === 'sticky' || ipos === 'fixed') {
          var h = Math.max(inner.getBoundingClientRect().height || 0, themeHeader.getBoundingClientRect().height || 0);
          return Math.floor(h);
        }
        return 0;
      };
      var setHeaderVar = function () { root.style.setProperty('--rf-header-h', headerH() + 'px'); };
      setHeaderVar();
      window.addEventListener('resize', setHeaderVar, { passive: true });

      /* ── the theme scrolls the window on mobile but an inner wrapper on desktop: find the real scroller ── */
      var scroller = (function () {
        var el = root.parentElement;
        while (el && el !== document.body && el !== document.documentElement) {
          var s = getComputedStyle(el);
          if (/(auto|scroll)/.test(s.overflowY) && el.scrollHeight > el.clientHeight + 1) return el;
          el = el.parentElement;
        }
        return null;
      })();
      var scrollTarget = scroller || window;
      var currentScroll = function () { return scroller ? scroller.scrollTop : (window.pageYOffset || document.documentElement.scrollTop); };
      var scrollerTop = function () { return scroller ? scroller.getBoundingClientRect().top : 0; };

      /* ── in-page jumps: buttons only, never anchors, so the theme's page transitions stay out of it ── */
      var nav = root.querySelector('.rf-sci__nav');
      var offset = function () { return headerH() + (nav ? nav.offsetHeight : 0) + 20; };
      var scrollTo = function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        if (id === 'rf-sources') {
          var d = root.querySelector('#rf-sources-details');
          if (d) d.open = true;
        }
        var top = el.getBoundingClientRect().top - scrollerTop() + currentScroll() - offset();
        try { scrollTarget.scrollTo({ top: top, behavior: 'smooth' }); } catch (e) { scrollTarget.scrollTo(0, top); }
      };
      root.querySelectorAll('[data-rf-scroll]').forEach(function (b) {
        b.addEventListener('click', function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          scrollTo(b.getAttribute('data-rf-scroll'));
        });
      });

      /* ── progress nav: current = filled, previous = dimmed, upcoming = plain ── */
      var chips = Array.prototype.slice.call(root.querySelectorAll('.rf-sci__chips button'));
      var ids = chips.map(function (b) { return b.getAttribute('data-rf-scroll'); });
      var setActive = function (id) {
        var idx = ids.indexOf(id);
        if (idx < 0) return;
        chips.forEach(function (b, i) {
          b.classList.toggle('is-active', i === idx);
          b.classList.toggle('is-past', i < idx);
        });
        var active = chips[idx];
        var strip = root.querySelector('.rf-sci__chips');
        if (active && strip && strip.scrollWidth > strip.clientWidth + 2) {
          var target = active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2;
          try { strip.scrollTo({ left: Math.max(0, target), behavior: 'smooth' }); } catch (e) { strip.scrollLeft = Math.max(0, target); }
        }
      };
      var sections = ids.map(function (id) { return document.getElementById(id); }).filter(Boolean);
      var onScroll = function () {
        var line = scrollerTop() + headerH() + (nav ? nav.offsetHeight : 0) + Math.min(160, window.innerHeight * 0.25);
        var current = sections[0] ? sections[0].id : null;
        for (var i = 0; i < sections.length; i++) {
          if (sections[i].getBoundingClientRect().top <= line) current = sections[i].id;
        }
        if (current) setActive(current);
      };
      var ticking = false;
      var onScrollEvent = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { setHeaderVar(); onScroll(); ticking = false; });
      };
      scrollTarget.addEventListener('scroll', onScrollEvent, { passive: true });
      if (scroller) window.addEventListener('scroll', onScrollEvent, { passive: true });
      onScroll();

      /* ── footnotes: popover anchored to the number, positioned inside the root ── */
      var pop = root.querySelector('.rf-sci__pop');
      var popBody = pop ? pop.querySelector('.rf-sci__pop-body') : null;
      var srcFor = function (n) { return root.querySelector('#rf-src-' + n); };
      var closePop = function () {
        if (!pop || pop.hidden) return;
        pop.hidden = true;
        pop.removeAttribute('data-open');
        root.querySelectorAll('.rf-sci__fn button[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      };
      var openPop = function (btn) {
        var n = btn.getAttribute('data-ref');
        var li = srcFor(n);
        if (!pop || !li) return;
        popBody.innerHTML = '<span class="rf-sci__pop-num">' + n + '</span>' + li.innerHTML;
        pop.hidden = false;
        pop.style.visibility = 'hidden';
        var rootRect = root.getBoundingClientRect();
        var r = btn.getBoundingClientRect();
        var pw = pop.offsetWidth;
        var ph = pop.offsetHeight;
        var left = r.left - rootRect.left + r.width / 2 - pw / 2;
        var minLeft = 12 - rootRect.left;
        var maxLeft = window.innerWidth - pw - 12 - rootRect.left;
        left = Math.max(minLeft, Math.min(left, maxLeft));
        var below = r.bottom - rootRect.top + 10;
        var spaceBelow = window.innerHeight - r.bottom;
        var top = spaceBelow < ph + 24 ? r.top - rootRect.top - ph - 10 : below;
        pop.classList.toggle('rf-sci__pop--above', spaceBelow < ph + 24);
        pop.style.left = left + 'px';
        pop.style.top = top + 'px';
        pop.style.setProperty('--rf-pop-arrow', (r.left - rootRect.left + r.width / 2 - left) + 'px');
        pop.style.visibility = '';
        pop.setAttribute('data-open', n);
        root.querySelectorAll('.rf-sci__fn button[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        btn.setAttribute('aria-expanded', 'true');
      };
      var bindFn = function (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-haspopup', 'dialog');
        var n = btn.getAttribute('data-ref');
        var li = srcFor(n);
        if (li) btn.setAttribute('title', li.getAttribute('data-short') || '');
        btn.addEventListener('click', function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          if (pop && !pop.hidden && pop.getAttribute('data-open') === n) { closePop(); return; }
          openPop(btn);
        });
      };
      root.querySelectorAll('.rf-sci__fn button').forEach(bindFn);
      if (pop) {
        pop.querySelector('.rf-sci__pop-close').addEventListener('click', closePop);
        pop.addEventListener('click', function (ev) { ev.stopPropagation(); });
        document.addEventListener('click', closePop);
        document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closePop(); });
      }

      /* ── per section: the numbers used, as plain footnote buttons (links live in the list at the bottom) ── */
      var label = root.getAttribute('data-sources-label') || 'Sources';
      root.querySelectorAll('.rf-sci__section').forEach(function (sec) {
        if (sec.id === 'rf-sources') return;
        var seen = {}; var order = [];
        sec.querySelectorAll('.rf-sci__fn button').forEach(function (b) {
          var n = b.getAttribute('data-ref');
          if (!seen[n]) { seen[n] = true; order.push(n); }
        });
        if (!order.length) return;
        var wrap = document.createElement('div');
        wrap.className = 'rf-sci__refs';
        wrap.innerHTML = '<span class="rf-sci__refs-label">' + label + '</span>';
        order.forEach(function (n) {
          var li = srcFor(n);
          if (!li) return;
          var sup = document.createElement('sup');
          sup.className = 'rf-sci__fn';
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('data-ref', n);
          b.textContent = n;
          sup.appendChild(b);
          wrap.appendChild(sup);
          bindFn(b);
        });
        sec.appendChild(wrap);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-science"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.rf-sci');
    roots.forEach(function (root) {
      var links = Array.prototype.slice.call(root.querySelectorAll('.rf-sci__chips a'));
      if (!links.length || !('IntersectionObserver' in window)) return;
      var byId = {};
      links.forEach(function (a) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        var el = document.getElementById(id);
        if (el) byId[id] = a;
      });
      var setActive = function (id) {
        links.forEach(function (a) { a.classList.toggle('is-active', a === byId[id]); });
        var active = byId[id];
        if (active && active.scrollIntoView) {
          try { active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) {}
        }
      };
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      }, { rootMargin: '-40% 0px -55% 0px', threshold: 0 });
      Object.keys(byId).forEach(function (id) { io.observe(document.getElementById(id)); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
